module.exports = __webpack_public_path__ + "static/media/bg-login.740b9673.png";